import styled from "styled-components";

export const Corousel1Wrapper = styled.div`
  position: relative;
  height: 400px;
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 25px;
  overflow: hidden;
`;

export const Corousel1FadingDiv = styled.div`
  position: absolute;
  height: 370px;
  width: 50px;
  z-index: 1;
  right: ${({ appear }) => (appear ? "0px" : "")};
  left: ${({ appear }) => (appear ? "" : "0px")};
  /* background-image: ${({ appear }) =>
    appear
      ? "linear-gradient(to right, red, green)"
      : "linear-gradient(to right, red, green)"}; */
`;

export const Corousel1ImageContainer = styled.div`
  position: absolute;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 310px;
  width: 200px;
  overflow: hidden;
  transition: transform 1s;
  :hover {
    cursor: pointer;
    transform: scale(1.25);
  }
`;

export const Corousel1Image = styled.img`
  height: 300px;
  width: 200px;
`;

export const Corousel1ImageDescription = styled.div`
  @keyframes moveUp {
    0% {
      bottom: -150px;
    }
    100% {
      bottom: 0px;
    }
  }
  @keyframes moveDown {
    0% {
      bottom: 0px;
    }
    100% {
      bottom: -150px;
    }
  }
  position: absolute;
  height: 150px;
  bottom: ${({ animationName }) =>
    animationName === "moveUp" ? "0px" : "-150px"};
  padding: 5px 7px;
  background-color: #00ffa182;
  color: black;
  text-align: justify;
  font-size: 1.5ch;
  animation: ${({ animationName }) => animationName} 1s;
`;

export const Corousel2Wrapper = styled.div`
  position: relative;
  margin: auto 0px;
  transform: translateY(-40px);
  padding-bottom: 40px;
  height: 560px;
  display: flex;
  align-items: center;
  /* border: 1px solid red; */
  flex-wrap: nowrap;
  overflow: hidden;
`;
export const Corousel2ImageContainer = styled.div`
  font-family: Oswald;
  flex-shrink: 0;
  position: relative;
  height: 500px;
  width: 70vw;
  /* border: 1px solid black; */
  margin-left: 5vw;
  :first-child {
    margin-left: ${({ selectedSlide }) => 11 - selectedSlide * 75}vw;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  transition: margin-left 0.5s;
  cursor: pointer;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    transition: all 1s ease-in-out;
    :hover {
      transform: scale(1.1);
    }
  }
  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: ${({ selected }) => !selected && "100%"};
    width: 100%;
    background-color: ${({ theme }) => theme.color1}ef;
    z-index: 1;
  }
`;

export const Corousel2Controls = styled.div`
  position: absolute;
  left: 50%;
  bottom: 15px;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Corousel2Control = styled.div`
  width: 30px;
  height: 10px;
  background-color: ${({ selected, theme }) =>
    selected ? theme.color1 : theme.color1 + "88"};
  margin-left: 5px;
  cursor: pointer;
  border-radius: 10px;
  /* border: 0.5px solid; */
`;
export const RightArrowWrapper = styled.div`
  position: absolute;
  right: 20px;
  width: 30px;
  height: 100%;
  display: ${({ visible }) => (visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 2;
  i {
    font-size: 2em;
    color: ${({ theme }) => theme.color3};
    cursor: pointer;
    transition: all 0.5s;
    :hover {
      transform: scale(1.2);
    }
  }
  @media screen and (max-width: 576px) {
    right: 0px;
  }
`;
export const LeftArrowWrapper = styled.div`
  position: absolute;
  left: 20px;
  width: 30px;
  height: 100%;
  display: ${({ visible }) => (visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 2;
  i {
    font-size: 2em;
    color: ${({ theme }) => theme.color3};
    cursor: pointer;
    transition: all 0.5s;
    :hover {
      transform: scale(1.2);
    }
  }
  @media screen and (max-width: 576px) {
    left: 0px;
  }
`;
export const PlayPauseWrapper = styled.div`
  position: absolute;
  right: 50px;
  bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  @media screen and (max-width: 576px) {
    right: 10px;
  }
`;

export const Icon = styled.i`
  display: ${({ visible }) => !visible && "none"};
  font-size: 1.5em;
  color: ${({ theme }) => theme.color1}88;
  cursor: pointer;
  transition: all 0.5s;
  :hover {
    transform: scale(1.2);
    color: ${({ theme }) => theme.color1};
  }
`;
export const SlideTextWrapper = styled.div`
  position: absolute;
  left: 10px;
  bottom: 10px;
  width: 40%;
  background-color: #debebe5e;
  border-radius: 10px;
  @media screen and (max-width: 576px) {
    width: 90%;
  }
`;

export const H1 = styled.h1`
  font-size: 6ch;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.color1};
  @media screen and (max-width: 576px) {
    font-size: 4ch;
  }
`;
export const P = styled.div`
  color: ${({ theme }) => theme.color3};
  font-size: 4ch;
  @media screen and (max-width: 576px) {
    font-size: 2ch;
  }
`;
